import { computed } from 'vue';
import { OrganisationsCampaignManagementAPIClient, MinimalOrganisationDto } from '@studyportals/campaign-management-api-interface';
import { ModalErrorStates } from '@/models/modal/modal.enum';
import { ISearchResult } from '@/models/search.interface';
import cookieHandler from '@/infrastructure/cookie-handler';
import rollbarOperator from '@/infrastructure/rollbar-operator';
import store from '@/store';

class CampaignPresenter {
	private client: OrganisationsCampaignManagementAPIClient;
	private readonly tokenId: string;
	private readonly limit = 30;

	private linkedOrganisations = computed((): MinimalOrganisationDto[] => {
		return store.getters.linkedOrganisations();
	});

	constructor() {
		this.client = new OrganisationsCampaignManagementAPIClient(webpackDefinitions.CAMPAIGN_MANAGEMENT_API_URL);
		this.tokenId = cookieHandler.retrieveTokenIdCookie();
	}

	public async fetchRelevantOrganisations(query: string): Promise<ISearchResult[]> {
		let organisations: MinimalOrganisationDto[] = [];

		try {
			organisations = await this.client.searchOrganisations(query, this.tokenId, this.limit);
		} catch (e) {
			rollbarOperator.triggerError(e as Error);
			store.mutations.setModalErrorState(ModalErrorStates.SEARCH_ORGANISATIONS);
		}

		return organisations
			.filter((organisation) => !this.linkedOrganisations.value.some(
				(linkedOrganisation) => linkedOrganisation.id === organisation.id)
			)
			.map((item) => ({
				name: item.name,
				id: item.id
			}));
	}
}

export default new CampaignPresenter();
